export default "__VITE_ASSET__kuQjp0dc__";